import styled from "styled-components";
import { SP_BREAKPOINT } from "../../constants/app";
import { Button } from "../atoms/Button";

export type DetailItem = {
  name: string;
  value: string;
};

type Props = {
  detailItems: DetailItem[];
  onCancel: () => void;
  onEdit: () => void;
  canEdit?: boolean;
};

export const DetailTemplate: React.FC<Props> = ({
  detailItems,
  onCancel,
  onEdit,
  canEdit = true,
}) => {
  return (
    <StyledDetailTemplateContainer>
      <StyledScrollableContent>
        {detailItems.map((item, index) => (
          <StyledDetailItem key={index} className={"detail"}>
            <StyledName>{item.name}</StyledName>
            <StyledValue>{item.value}</StyledValue>
          </StyledDetailItem>
        ))}
      </StyledScrollableContent>

      <StyledFooter>
        <Button text="戻る" variant="dark" onClick={onCancel} />
        {canEdit && <Button text="編集" variant="filled" onClick={onEdit} />}
      </StyledFooter>
    </StyledDetailTemplateContainer>
  );
};

const StyledDetailTemplateContainer = styled.div`
  @media (max-width: ${SP_BREAKPOINT}) {
    padding: 0;
  }
  display: flex;
  flex-direction: column;
  padding: 0 10%;
  max-height: 100%;
  overflow: hidden;
`;

const StyledScrollableContent = styled.div`
  overflow-y: auto;
  padding-bottom: 20px;

  @media (max-width: ${SP_BREAKPOINT}) {
    padding: 0;
    overflow-y: auto;
  }
`;

const StyledDetailItem = styled.div`
  display: flex;
  padding: 16px 14px;
  align-items: center;
  gap: 26px;
  align-self: stretch;
  border-bottom: 1px solid #e6e6e6;

  div {
    flex: 1;
  }
  &:not(:has(~ .detail)) {
    border-bottom: none;
  }
`;

const StyledName = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 100%;
`;

const StyledValue = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 100%;
  max-width: 748px;
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;

  @media (max-width: ${SP_BREAKPOINT}) {
    line-height: 150%;
  }
`;

const StyledFooter = styled.div`
  @media (max-width: ${SP_BREAKPOINT}) {
    justify-content: center;
    margin: 0;

    button {
      width: 100%;
    }
  }

  display: flex;
  justify-content: flex-end;
  gap: 16px;
  margin: 38px 0;
  padding-top: 32px;
  border-top: solid 1px #ccc;

  &:not(:has(+ *)) {
    margin: 0 0 30px;
  }
`;
